import LogUtil from './../../../../core/utils/logUtil';
import {gsap} from 'gsap';

export default class StepController {

    private static _timeline: any;
    private static steps: any;
    private static target: HTMLElement;
    private static data: any;
    private static current_step: any;

    static setTimeline(onComplete?:any) {
        StepController._timeline = gsap.timeline({paused: false, onComplete: onComplete ?? undefined});
    }

    static setSteps(steps) {

        StepController.steps = steps;
    }

    static setTarget(target) {

        StepController.target = target;
    }

    static setData(data) {
        StepController.data = data;
    }

    static nextStep(stepName, previousStep?:any) {

        let next = () => {

            LogUtil.logClass(StepController, 'Next step in view:', stepName);

            StepController.current_step = StepController.steps[stepName];
            StepController.current_step.appendTo(StepController.target);
            StepController.current_step.init(StepController.data);

            StepController.current_step.show(StepController._getTimeline());
        };


        if (previousStep) {

            previousStep.hide(StepController._getTimeline(), next);
        }
        else {

            next();
        }
    }

    static _getTimeline() {

        return StepController._timeline;
    }
}
